// One date format across the portal: "30 Sep 2026" and "30 Sep 2026, 1:02 PM".
const toValidDate = (value) => {
    if (value === null || value === undefined || value === '') return null;
    const date = value instanceof Date ? value : new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
};

export const formatDisplayDate = (value) => {
    const date = toValidDate(value);
    if (!date) return '—';
    const month = date.toLocaleDateString('en-US', { month: 'short' });
    return `${date.getDate()} ${month} ${date.getFullYear()}`;
};

export const formatDisplayDateTime = (value) => {
    const date = toValidDate(value);
    if (!date) return '—';
    const time = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
    return `${formatDisplayDate(date)}, ${time}`;
};
